import { render } from "./EditorColorPicker.vue?vue&type=template&id=961efb44&ts=true"
import script from "./EditorColorPicker.vue?vue&type=script&lang=ts"
export * from "./EditorColorPicker.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__